import type { CSSProperties, ReactNode } from "react";

export type SourceToken = { content: string; color?: string; fontStyle?: number };
export type SourceTokenLines = SourceToken[][];

export function sourceTokenStyle(token: SourceToken): CSSProperties {
  const bits = token.fontStyle ?? 0;
  const decorations = [bits & 4 ? "underline" : "", bits & 8 ? "line-through" : ""].filter(Boolean).join(" ");
  return {
    ...(token.color ? { color: token.color } : {}),
    ...(bits & 1 ? { fontStyle: "italic" } : {}),
    ...(bits & 2 ? { fontWeight: 700 } : {}),
    ...(decorations ? { textDecorationLine: decorations } : {}),
  };
}

export function sourceTokenChildren(lines: SourceTokenLines): ReactNode[] {
  let sourceOffset = 0;
  return lines.flatMap((line, lineIndex) => {
    const tokens: ReactNode[] = line.map((token) => {
      const startsAt = sourceOffset;
      sourceOffset += token.content.length;
      return (
        <span key={startsAt} style={sourceTokenStyle(token)}>
          {token.content}
        </span>
      );
    });
    if (lineIndex < lines.length - 1) {
      sourceOffset += 1;
      tokens.push("\n");
    }
    return tokens;
  });
}
